<template>
  <BaseBadge :variant="variant">
    {{ text }}
  </BaseBadge>
</template>

<script lang="ts" setup>
import BaseBadge from '@/components/base/BaseBadge.vue'
import { ref, watch } from 'vue'

const props = defineProps({
  status: {
    type: String,
    required: true
  }
})

const variant = ref<'base' | 'secondary' | 'info' | 'success' | 'error'>('base')
const text = ref<string>('')

watch(()=>props.status, () => {

  switch (props.status) {
    case 'accepted':
      variant.value = 'base'
      text.value = 'Accepted'
      break
    case 'scheduled':
      variant.value = 'secondary'
      text.value = 'Scheduled'
      break
    case 'in_progress':
      variant.value = 'success'
      text.value = 'In Progress'
      break
    case 'on_hold':
      variant.value = 'error'
      text.value = 'On Hold'
      break
    case 'completed':
      text.value = 'Completed'
      variant.value = 'info'
      break
  }
}, { immediate: true })

</script>
